// extracted by mini-css-extract-plugin
module.exports = {"checkBoxGroup":"CategoryPageAddEditModal_checkBoxGroup__1N6Zw","checkBoxRow":"CategoryPageAddEditModal_checkBoxRow__QlqlW"};